var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeuralconnectLogoBlackXsmall1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 102 14",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.4096 0 0 .45958 -2.6813 -.20823)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.902,
    y: 0.453,
    width: 72.129,
    height: 29.742,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.39153 0 0 1.2009 -11.879 1.899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 40.49 15.662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.958-1.958c-1.081 0-1.958 0.877-1.958 1.958s0.877 1.958 1.958 1.958 1.958-0.877 1.958-1.958-0.877-1.958-1.958-1.958",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 50.742 8.1379)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.926-2.926c-1.616 0-2.926 1.311-2.926 2.926 0 1.616 1.31 2.926 2.926 2.926s2.926-1.31 2.926-2.926c0-1.615-1.31-2.926-2.926-2.926",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 46.429 13.726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.957-1.957c-1.083 0-1.958 0.876-1.958 1.957s0.875 1.957 1.958 1.957c1.081 0 1.958-0.876 1.958-1.957s-0.877-1.957-1.958-1.957",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 44.89 6.9946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.958-1.958c-1.082 0-1.958 0.877-1.958 1.958s0.876 1.958 1.958 1.958c1.081 0 1.958-0.877 1.958-1.958s-0.877-1.958-1.958-1.958",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 56.768 7.127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-2.266-2.266c-1.251 0-2.266 1.014-2.266 2.265 0 1.252 1.015 2.267 2.266 2.267s2.266-1.015 2.266-2.267c0-1.251-1.015-2.265-2.266-2.265",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 51.885 .5712)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.958-1.958c-1.082 0-1.958 0.877-1.958 1.958s0.876 1.958 1.958 1.958c1.081 0 1.958-0.877 1.958-1.958s-0.877-1.958-1.958-1.958",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 40.886 2.0678)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.957-1.957c-1.082 0-1.958 0.876-1.958 1.958 0 1.08 0.876 1.956 1.958 1.956 1.081 0 1.958-0.876 1.958-1.956 0-1.082-0.877-1.958-1.958-1.958",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 53.161 17.421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.738-1.737c-0.959 0-1.737 0.778-1.737 1.737 0 0.96 0.778 1.738 1.737 1.738 0.96 0 1.738-0.778 1.738-1.738 0-0.959-0.778-1.737-1.738-1.737",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 51.137 14.386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.517-1.517c-0.839 0-1.519 0.68-1.519 1.518 0 0.836 0.68 1.516 1.519 1.516 0.837 0 1.518-0.68 1.518-1.516 0-0.838-0.681-1.518-1.518-1.518",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 43.877 11.482)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.297-1.299c-0.717 0-1.298 0.581-1.298 1.299 0 0.716 0.581 1.297 1.298 1.297 0.716 0 1.297-0.581 1.297-1.297 0-0.718-0.581-1.299-1.297-1.299",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 56.856 12.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.914-1.914c-1.057 0-1.913 0.857-1.913 1.913 0 1.058 0.856 1.915 1.913 1.915s1.914-0.857 1.914-1.915c0-1.056-0.857-1.913-1.914-1.913",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 43.262 19.181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.298-1.298c-0.717 0-1.298 0.581-1.298 1.298s0.581 1.298 1.298 1.298 1.298-0.581 1.298-1.298-0.581-1.298-1.298-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 46.408 18.191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.298-1.297c-0.717 0-1.297 0.581-1.297 1.298 0 0.716 0.58 1.297 1.297 1.297s1.298-0.581 1.298-1.297c0-0.717-0.581-1.298-1.298-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 49.751 19.819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.298-1.298c-0.717 0-1.298 0.581-1.298 1.298s0.581 1.298 1.298 1.298 1.298-0.581 1.298-1.298-0.581-1.298-1.298-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 37.719 11.218)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.298-1.298c-0.717 0-1.298 0.581-1.298 1.298s0.581 1.298 1.298 1.298c0.716 0 1.298-0.581 1.298-1.298s-0.582-1.298-1.298-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 41.04 6.8406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.298-1.298c-0.717 0-1.298 0.581-1.298 1.298s0.581 1.298 1.298 1.298 1.298-0.581 1.298-1.298-0.581-1.298-1.298-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 37.652 7.2806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.298-1.298c-0.717 0-1.298 0.58-1.298 1.298 0 0.717 0.581 1.298 1.298 1.298 0.716 0 1.298-0.581 1.298-1.298 0-0.718-0.582-1.298-1.298-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 48.408 5.5872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.297-1.299c-0.717 0-1.298 0.581-1.298 1.299 0 0.716 0.581 1.297 1.298 1.297 0.716 0 1.297-0.581 1.297-1.297 0-0.718-0.581-1.299-1.297-1.299",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 54.093 4.8045)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.297-1.299c-0.717 0-1.298 0.581-1.298 1.299 0 0.716 0.581 1.297 1.298 1.297s1.297-0.581 1.297-1.297c0-0.718-0.58-1.299-1.297-1.299",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 45.021 2.9481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.297-1.298c-0.717 0-1.298 0.581-1.298 1.298s0.581 1.297 1.298 1.297 1.297-0.58 1.297-1.297-0.58-1.298-1.297-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 48.145 -2e-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.298-1.298c-0.717 0-1.298 0.581-1.298 1.298s0.581 1.298 1.298 1.298 1.298-0.581 1.298-1.298-0.581-1.298-1.298-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 43.284 .4614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.401 0-0.726 0.325-0.726 0.726s0.325 0.726 0.726 0.726c0.4 0 0.726-0.325 0.726-0.726s-0.326-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 45.594 .8696)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.4 0-0.726 0.325-0.726 0.727 0 0.4 0.326 0.725 0.726 0.725 0.401 0 0.726-0.325 0.726-0.725 0-0.402-0.325-0.727-0.726-0.727",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 47.683 3.4971)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.401 0-0.726 0.325-0.726 0.726s0.325 0.726 0.726 0.726c0.4 0 0.726-0.325 0.726-0.726s-0.326-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 55.404 3.0581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.725c-0.401 0-0.726 0.324-0.726 0.726 0 0.401 0.325 0.724 0.726 0.724s0.726-0.323 0.726-0.724c0-0.402-0.325-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 43.284 5.521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.4 0-0.726 0.325-0.726 0.726s0.326 0.726 0.726 0.726c0.401 0 0.726-0.325 0.726-0.726s-0.325-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 50.631 4.5977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.725c-0.402 0-0.726 0.324-0.726 0.726 0 0.401 0.324 0.724 0.726 0.724 0.401 0 0.726-0.323 0.726-0.724 0-0.402-0.325-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 51.855 6.4995)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.402 0-0.726 0.325-0.726 0.727 0 0.4 0.324 0.725 0.726 0.725 0.401 0 0.727-0.325 0.727-0.725 0-0.402-0.326-0.727-0.727-0.727",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 57.054 5.0811)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.401 0-0.726 0.325-0.726 0.727 0 0.4 0.325 0.725 0.726 0.725s0.726-0.325 0.726-0.725c0-0.402-0.325-0.727-0.726-0.727",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 39.017 5.8296)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.725c-0.402 0-0.726 0.324-0.726 0.726 0 0.401 0.324 0.724 0.726 0.724 0.401 0 0.726-0.323 0.726-0.724 0-0.402-0.325-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,39.544,9.7007)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.727c-0.402 0-0.727 0.325-0.727 0.726s0.325 0.726 0.727 0.726c0.4 0 0.726-0.325 0.726-0.726s-0.326-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 44.032 17.443)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.401 0-0.726 0.325-0.726 0.727 0 0.4 0.325 0.725 0.726 0.725s0.726-0.325 0.726-0.725c0-0.402-0.325-0.727-0.726-0.727",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 38.093 14.408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.725c-0.402 0-0.726 0.324-0.726 0.726 0 0.401 0.324 0.724 0.726 0.724 0.401 0 0.726-0.323 0.726-0.724 0-0.402-0.325-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,-1,-1,0,41.92,10.229)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.725c-0.402 0-0.726 0.324-0.726 0.726 0 0.4 0.324 0.724 0.726 0.724 0.401 0 0.726-0.324 0.726-0.724 0-0.402-0.325-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 46.979 11.416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.401 0-0.726 0.324-0.726 0.726 0 0.4 0.325 0.726 0.726 0.726s0.726-0.326 0.726-0.726c0-0.402-0.325-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 55.954 16.784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.725c-0.402 0-0.726 0.324-0.726 0.726 0 0.401 0.324 0.724 0.726 0.724 0.401 0 0.726-0.323 0.726-0.724 0-0.402-0.325-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 54.018 15.2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.727c-0.402 0-0.727 0.324-0.727 0.726 0 0.401 0.325 0.726 0.727 0.726 0.4 0 0.726-0.325 0.726-0.726 0-0.402-0.326-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 48.871 17.312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.725-0.726c-0.401 0-0.727 0.324-0.727 0.726 0 0.4 0.326 0.725 0.727 0.725 0.4 0 0.726-0.325 0.726-0.725 0-0.402-0.326-0.726-0.726-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 54.591 11.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.401 0-0.726 0.325-0.726 0.726s0.325 0.726 0.726 0.726 0.727-0.325 0.727-0.726-0.326-0.726-0.727-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 43.064 14.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.401 0-0.726 0.325-0.726 0.727 0 0.4 0.325 0.725 0.726 0.725s0.726-0.325 0.726-0.725c0-0.402-0.325-0.727-0.726-0.727",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 46.892 21.183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-0.726-0.726c-0.401 0-0.726 0.325-0.726 0.726s0.325 0.726 0.726 0.726 0.727-0.325 0.727-0.726-0.326-0.726-0.727-0.726",
    fill: "#231f20",
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0 -1 -1 0 40.842 12.45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.297-1.297c-0.716 0-1.299 0.581-1.299 1.298 0 0.715 0.583 1.296 1.299 1.296 0.717 0 1.298-0.581 1.298-1.296 0-0.717-0.581-1.298-1.298-1.298",
    fill: "#231f20",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.647 0 0 8.1189 11.693 23.212)"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "rgb(35,31,32)",
    fontFamily: "'SFProText-Semibold', 'SF Pro Text'",
    fontSize: "2.68px",
    fontWeight: 600
  }, "NeuralConnect")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeuralconnectLogoBlackXsmall1);
export default __webpack_public_path__ + "static/media/neuralconnect-logo-black-xsmall-1.fbae2fed0ef4a47e9cf6ac7eb8c14bb1.svg";
export { ForwardRef as ReactComponent };